<div data-test-id="dxp-background-background"  class="background">
  <img data-test-id="dxp-background-background-image"  src="/assets/dxp/img/background.png" alt="" srcset="" />
</div>
